import { List } from 'immutable'
import { HttpResult } from 'widgets-for-react'
import { HeaderItem, UtilityItem } from './headerState'

type HeaderData = {
  NavigationItem: {
    Title: string
    InternalLink: {
      Path: string
      ContentType: string
    } | null
    ExternalLink: {
      Title: string
      Url: string
    }
  }
  Children: {
    NavigationItem: {
      Title: string
      InternalLink: {
        Path: string
        ContentType: string
      } | null
      ExternalLink: {
        Title: string
        Url: string
      }
    }
  }[]
}[]

type UtilityData = {
  Title: string
  InternalLink: {
    Title: string
    Path: string
  }
  ExternalLink: {
    Title: string
    Url: string
  }
}[]

export const headerApi = async (): Promise<HttpResult<List<HeaderItem>>> => {
  const res = await fetch('/api/v1/lists/primary_navigation')

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: HeaderData = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: List(
      data.map((item) => ({
        opened: false,
        title: item.NavigationItem.Title,
        url: item.NavigationItem.InternalLink ? item.NavigationItem.InternalLink.Path : item.NavigationItem.ExternalLink.Url,
        children: item.Children.map((child) =>
          child.NavigationItem.InternalLink
            ? {
                title: child.NavigationItem.Title,
                url: child.NavigationItem.InternalLink.Path,
              }
            : {
                title: child.NavigationItem.Title,
                url: child.NavigationItem.ExternalLink.Url,
              }
        ),
      }))
    ),
  }
}

export const utilitesApi = async (): Promise<HttpResult<List<UtilityItem>>> => {
  const res = await fetch('/api/v1/lists/secondary_navigation')

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: UtilityData = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: List(
      data.map((item) => ({
        title: item.Title,
        url: item.InternalLink ? item.InternalLink.Path : item.ExternalLink.Url
      }))
    ),
  }
}
